/* eslint-disable max-len */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Checkbox, Confirm, Input} from 'semantic-ui-react';
import '../styles.scss';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {generateJson} from '../../utils/dataByLineUtils';

export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

const sumColumnsCreateOrder = [
  'deposit',
  'transit',
  'totalTransit',
  'available',
  'prioritized',
  'not_available',
  'totalStock',
  'totalUnits',
];

const transit = ['deposit', 'transit', 'totalTransit'];

const sum = (arr, id) =>
  arr.reduce((accumulator, object) => {
    return accumulator + parseInt(object.values[`${id}`] || 0, 10);
  }, 0);

export const DefaultColumnFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <div className="full-width">
      <Input
        className="input-custom-small"
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || null);
        }}
      />
    </div>
  );
};

const jsonToParams = (json) => {
  return Object.keys(json).map((key) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
  }).join('&');
};

export const InventoryColumnFilter = ({
  'column': {filterValue, setFilter, id, preFilteredRows},
  requestData,
}) => {
  const params = {
    'dealer': requestData?.dealer,
    'destiny': requestData?.destiny,
  };
  return (
    <>
      {!sumColumnsCreateOrder.includes(id) ? (
        <span></span>
      ) : (
        <>
          {id === 'totalUnits' ? (
            <span>{sum(preFilteredRows, id)}</span>
          ) : (
            <Link
              to={`/vehiculos/administracion-inventario/all?group=${
                transit.includes(id) ? 'transit' : 'stock'
              }&type=${id}&${jsonToParams(params)}`}
            >
              {sum(preFilteredRows, id) || 0}
            </Link>
          )}
        </>
      )}
    </>
  );
};

const customColumnsInventoryByLine = ['available'];

const mapStateToProps = (state) => ({
  'loading': state.vehiclesInventory.loading,
  'filters': state.vehiclesInventory.filters,
  'modelsByLine': state.vehiclesInventory.modelsByLine,
});

const {fetchUpdateModelsLine} = Actions;

const isAllAvailable = (data) => {
  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].available === 'N') {
        return false;
      }
    }
    return true;
  }
  return false;
};

export const InventoryLinesColumnFilter = connect(mapStateToProps, {
  fetchUpdateModelsLine,
})(
  ({
    'column': {filterValue, setFilter, id, preFilteredRows},
    fetchUpdateModelsLine,
    filters,
    modelsByLine,
  }) => {
    const [showConfirm, setShowConfirm] = useState(false);

    const data = preFilteredRows.map((row) => {
      return row.original;
    });

    const handleChange = (field, newValue) => {
      const dataForQuery = generateJson(data, field, '', newValue, filters);
      fetchUpdateModelsLine(dataForQuery);
      setShowConfirm(false);
    };
    const isAllDataAvailable = isAllAvailable(data || []);
    return (
      <>
        {customColumnsInventoryByLine.includes(id) ? (
          <>
            <Checkbox
              checked={isAllDataAvailable}
              onChange={(e, {checked}) => setShowConfirm(true)}
              toggle
            />
            <Confirm
              header="¿Seguro que desea continuar?"
              content='Esta acción provocará que se modifique el campo "Disponible" de todas las líneas actuales.'
              cancelButton="Cancelar"
              confirmButton="Continuar"
              open={showConfirm}
              onCancel={() => setShowConfirm(false)}
              onConfirm={() =>
                handleChange(
                  'available',
                  !isAllDataAvailable ? 'S' : 'N',
                )
              }
            />
          </>
        ) : (
          <div className="full-width">
            <Input
              className="input-custom-small"
              value={filterValue || ''}
              onChange={(e) => {
                setFilter(e.target.value || null);
              }}
            />
          </div>
        )}
      </>
    );
  }
);
